/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.0): index.esm.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import Alert from "@openeuropa/bcl-bootstrap/js/src/alert";
import Button from "@openeuropa/bcl-bootstrap/js/src/button";
import Carousel from "@openeuropa/bcl-bootstrap/js/src/carousel";
import Collapse from "@openeuropa/bcl-bootstrap/js/src/collapse";
import Dropdown from "@openeuropa/bcl-bootstrap/js/src/dropdown";
import Modal from "@openeuropa/bcl-bootstrap/js/src/modal";
import MainNavigation from "./main-navigation/main-navigation";
import MegaMenu from "./mega-menu/mega-menu";
import Offcanvas from "@openeuropa/bcl-bootstrap/js/src/offcanvas";
import Popover from "@openeuropa/bcl-bootstrap/js/src/popover";
import ScrollSpyV2 from "@openeuropa/bcl-bootstrap/js/src/scrollspy";
import ScrollSpy from "@openeuropa/bcl-bootstrap/js/src/scrollspy-legacy";
import Tab from "@openeuropa/bcl-bootstrap/js/src/tab";
import Toast from "@openeuropa/bcl-bootstrap/js/src/toast";
import Tooltip from "@openeuropa/bcl-bootstrap/js/src/tooltip";
import AccordionToggle from "./accordion-toggle/accordion-toggle";
import Gallery from "./gallery/gallery";
import AccessibleToggle from "./accessible-toggle/accessible-toggle";
import Header from "./header/header";

export default {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  MainNavigation,
  MegaMenu,
  Offcanvas,
  Popover,
  ScrollSpyV2,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
  Gallery,
  AccessibleToggle,
  AccordionToggle,
  Header,
};
